<template>
  <transition name="slide">
    <v-snackbar
      v-if="loginSuccess"
      :value="true"
      :timeout="0"
      :top="true"
      color="success"
    >
      <v-icon color="white">
        mdi-account-check
      </v-icon>
      Welcome back
    </v-snackbar>
  </transition>
</template>

<style scoped>
@keyframes slideInTop {
  from {
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.slide-enter-active {
  animation: slideInTop 0.25s ease-out;
}

@keyframes slideOutTop {
  from {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
}

.slide-leave-active {
  animation: slideOutTop 0.25s ease-in;
}
</style>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["loginSuccess"])
  }
};
</script>
